<template>
    <div class="page-container">
        <van-nav-bar left-arrow fixed :z-index="10" @click-left="goableBack()" title="免责声明"></van-nav-bar>
        <h2 class="ta-c">
            天安互联网金融资产交易中心免责声明
        </h2>
        <div class="content" >
            <div>投资人依据自身独立判断，对标的金融资产进行投资，投资人在做出投资决策前，应全面了解相关投资标的，谨慎决策；投资人应对自身做出的判断承担全部责任，并自行承担全部风险。</div>
            <div>投资人在实施相关金融资产交易时应充分了解并认可，任何通过天安金交中心进行的交易并不能避免以下风险的产生，天安金交中心不能亦无义务为如下风险负责：</div>
            <div>（一）政策风险：本次资产转让是依照当前的法律法规、相关监管规定和政策设计的。如国家宏观政策以及市场法律法规、相关监管规定发生变化，可能影响资产转让的受理、回购、清算等业务的正常进行，并导致标的资产的本金及收益的损失、甚至为零的风险，也可能导致相关交易违反国家法律、 法规或者其他合同的有关规定，进而导致本资产转让被宣告无效、撤销、解除或提前终止等。</div>
            <div>（二）信用风险：本次转让资产的基础债权项下义务人可能出现违约情形，则客户可能面临本金及收益的损失、甚至为零的风险。</div>
            <div>（三）行业风险：本次转让资产的基础债权项下的义务人所处行业可能受经济运行周期性变化，以及所处行业的成熟阶段、上下游供求关系、内部竞争程度、替代品威胁等因素的负面影响，从而发生不利于投资人实现预期收益的变化乃至本金遭受损失。</div>
            <div>（四）市场风险：资金市场供求关系、货币政策、财政政策、行业政策等因素变化，以及整体经济形势变化，可能对利率、汇率、资金成本和商品价格等因素产生负面影响，从而不利于投资人实现预期收益乃至本金遭受损失。</div>
            <div>（五）购买力风险：投资的利润将主要通过现金形式来分配，而现金可能因为通货膨胀的影响而导致购买力下降，从而使投资的实际收益下降。</div>
            <div>（六) 信息传递风险：投资人应根据本次资产转让说明所载明的公告方式及时查询本次资产转让的相关信息。如果投资人未及时查询，或由于通讯故障、系统故障以及其他不可抗力等因素的影响使得投资人无法及时了解计划信息，并由此影响投资人的投资决策，因此而产生的责任和风险由投资人自行承担。</div>
            <div>（七）管理风险：本次转让资产的基础债权债权人受经验、技能、判断力、执行力等方面的限制，可能对基础债权管理造成一定影响，并因此影响客户收益，甚至收益为零的情况。</div>
            <div>（八）延期实现预期收益的风险：投资到期时，若发生前述信用风险，本次转让资产的基础债权人将使用适当的方式对融资方或保险机构进行追索或者要求履约，在此过程中，投资人有可能延期实现预期收益乃至本金遭受损失。</div>
            <div>（九）投资标的风险：在实际操作中，投资人可能因为项目未达最低转让标准、投资标的受让不成功或者投资标的提前终止而面临无法实现预期收益的风险。居间信息服务机构不保证本资产转让一定盈利,也不保证本次资产转让的最低收益。</div>
            <div>（十）操作风险 投资人可能面临如下操作风险：</div>
            <p>1. 不可预测或无法控制的系统故障、设备故障、通讯故障、停电等突发事故将有可能给投资人造成一定损失；</p>
            <p>2. 由于存在互联网和移动通讯网络的黑客恶意攻击可能性，投资人可能会遭受损失；</p>
            <p>3. 投资人的账号及密码信息可能被盗或被泄露，客户身份可能被仿冒，投资人可能遭受因此导致的损失；</p>
            <p>4. 投资人的网络终端设备及软件系统可能会受到非法攻击或病毒感染，导致电子签名合同数据无法传输或传输失败，从而遭受损失；</p>
            <p>5. 投资人操作不当等原因可能会造成损失；</p>
            <p>6. 网上交易、热键操作完毕，未及时退出，他人进行恶意操作将可能造成投资人损失；</p>
            <p>7. 由于投资人未能及时主动了解投资标的资产的信息，或由于通信故障、系统故障以及其他不可抗力等因素的影响，可能导致投资人无法及时做出合理决策，造成投资人损失；</p>
            <p>8. 投资人交由他人代理交易，或长期不关注账户变化，可能致使他人恶意操作而造成投资人损失。</p>
            <div>（十一）不可抗力风险：指由于自然灾害、战争等不可抗力因素的出现，将严重影响金融市场的正常运行，可能影响计划的交易、投资、回购等的正常进行，甚至导致本资产转让收益降低乃至本金损失。对于由不可抗力风险所导致的任何损失，由投资人自行承担。
            </div>
            <div>以上并不能揭示本次资产转让交易的全部风险及市场的所有情形。投资人在做出交易决策前，应通过天安金交中心公布的信息及其他相关公告了解拟投资标的的风险收益特征，并根据自身的交易目标、风险承受能力和资产状况等谨慎决策，并自行承担全部风险。</div>
        </div>
    </div>
</template>

<script>
    import { NavBar } from "vant";
    export default {
        name: "relief",
        components:{
            [NavBar.name]:NavBar
        }
    }
</script>

<style lang="less" scoped>
    .page-container {
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
    }
    p {
        text-indent: 20px;
    }
    h3 {
        text-align: center;
    }
    .content > div >b:first-child {
        margin-right: 14px;
    }
    .van-nav-bar {
        background: #fff;

        .van-nav-bar__title {
            color: @dark;
        }
        .van-icon {
            color: @dark !important;
        }
    }
</style>